import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsCheckbox as Checkbox } from './src/index.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(Checkbox);
export const FsCheckbox = customElementClass;
/** Export the element's canonical tag name for referenc in some build tools */
export const tagName = safeTagName;
//# sourceMappingURL=fs-checkbox.js.map